import { render, staticRenderFns } from "./B777.vue?vue&type=template&id=5d496dbf&scoped=true&"
import script from "./B777.vue?vue&type=script&lang=js&"
export * from "./B777.vue?vue&type=script&lang=js&"
import style0 from "./B777.vue?vue&type=style&index=0&id=5d496dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d496dbf",
  null
  
)

export default component.exports